
import { Vue, Component, Prop } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";

@Component
export default class SecurityGroupDialog extends Vue {
  @Prop() value!: boolean;
  @Prop({ default: () => [] }) excludedProfileIdx!: number[];
  resolve!: Function;

  profileFilterPredicate(up: any) {
    return !this.excludedProfileIdx.some((i) => i == up.id);
  }

  profileDataSource: ListDataSource = new ListDataSource({
    className: "profile",
    config: {
      pageIndex: 1,
      pageSize: 15,
    },
  });

  addByProfile(profile: any) {
    this.$emit("add-by-user-profile", profile.id);
  }
}
